import { Customer } from "app/common/Model/Customer";
import {
  getOrCreateNewByListSriId,
  markMultipleServiceAsCompletedByServiceRequestItem,
} from "app/services/DiagnosticReportService";
import { pagingServiceRequestItem } from "app/services/ServiceRequestItemService";
import { updateMutiplSriWthParticipantsAndImages } from "app/services/ServiceRequestItemStepService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import history from "history.js";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";

const DEFAULT_VALUE_PATIENT = {
  patientInfo: new Customer(),
};
const defaultValue = {
  ...new SearchObject(),
  orderDateFrom: new Date(),
  orderDateTo: new Date(),
  departmentIds: [],
};
export default class TreatmentUpdateImageAndTourStore {
  currentTab = 0;
  initMultipleSvItem = {
    // diagnosticReport: { performDate: new Date() },
  };

  searchTreatment = {
    ...defaultValue,
  };
  openPopupSelectedTreatment = false;
  selectedTreatmentList = [];
  pageTreatment = new PageResponse();
  initialPatient = {
    ...DEFAULT_VALUE_PATIENT,
  };
  selectedServiceTrement = [];
  openConfirmMessage = null;
  constructor() {
    makeAutoObservable(this);
  }

  setSelectedServiceTrement = (list) => {
    this.selectedServiceTrement = list;
  };

  handleMarkMultipleServiceCompleted = async () => {
    try {
      const allServices = this.selectedTreatmentList || [];

      if (!allServices.length) {
        toast.warning("Không có dịch vụ nào để đánh dấu!");
        return;
      }

      const ids = allServices.map((item) => item?.id).filter(Boolean);
      const { data } =
        await markMultipleServiceAsCompletedByServiceRequestItem(ids);
      const failures = data?.filter((item) => item?.responseStatus === false);
      if (failures?.length > 0) {
        setTimeout(() => {
          this.openConfirmMessage = failures[0]?.responseDetail;
        }, 500);
      } else {
        toast.success("Đánh dấu hoàn thành dịch vụ thành công!");
      }
    } catch (error) {
      console.error("Lỗi đánh dấu hoàn thành nhiều dịch vụ:", error);
      toast.error("Không thể đánh dấu hoàn thành, vui lòng thử lại!");
    }
  };

  handleClose = () => {
    this.openConfirmMessage = null;
  };

  setCurrentTab = (tab) => {
    this.currentTab = tab;
  };

  updateMutiplSriWthParticipantsAndImages = async (values) => {
    try {
      const { data } = await updateMutiplSriWthParticipantsAndImages(values);
      if (
        data &&
        Array.isArray(data) &&
        data.some((item) => item.responseStatus === false)
      ) {
        const errorItem = data.find((item) => item.responseStatus === false);
        this.openConfirmMessage =
          errorItem.responseDetail || "Cập nhật thất bại!";
        return;
      }
      toast.success(`Cập nhật thành công ${data?.length || 0} dịch vụ`);
    } catch (error) {
      toast.error(error);
    }
  };

  pagingTreatment = async () => {
    let { departmentIds, ...ortherData } = this.searchTreatment;
    if (departmentIds) {
      ortherData.departmentIds = departmentIds?.map((x) => x?.id) || [];
    }
    const urlParams = new URLSearchParams(window.location.search);
    const patientId = urlParams.get("patientId");
    return await pagingServiceRequestItem({
      ...ortherData,
      patientId,
    })
      .then(({ data }) => {
        this.pageTreatment = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu điều trị khách hàng có lỗi");
      });
  };

  setSelectedTreatmentList = (row) => {
    this.selectedTreatmentList = row;
  };

  handleRemoveSelectedTreatment = (item) => {
    const newList = this.selectedTreatmentList.filter(
      (el) => el?.id !== item?.id,
    );
    this.selectedTreatmentList = newList;
  };

  handleOpenPopupSelectedTreatment = () => {
    // this.pagingTreatment();
    this.openPopupSelectedTreatment = true;
  };

  handleClosePopupSelectedTreatment = () => {
    this.openPopupSelectedTreatment = false;
  };

  handleChangeFormSearchTreatment = (searchTreatment) => {
    this.searchTreatment = {
      ...this.searchTreatment,
      ...searchTreatment,
    };
    this.pagingTreatment();
  };

  handleSubmitUpdateMultipleTreatment = async () => {
    try {
      let Ids =
        this.selectedTreatmentList?.length > 0 &&
        this.selectedTreatmentList?.map((el) => el?.id);
      const { data } = await getOrCreateNewByListSriId(Ids);
      const failures = data?.filter((item) => item?.responseStatus === false);
      if (failures?.length > 0) {
        setTimeout(() => {
          this.openConfirmMessage = failures[0]?.responseDetail;
        }, 500);
        return;
      }
      this.handleClosePopupSelectedTreatment();
      return data;
    } catch (error) {
      toast.error(error);
    }
  };
}
